import React from 'react';
import styled from '@emotion/styled';
import { InfoOutlined } from '@mui/icons-material';
import mainContext from '../../../contexts/mainContext';
import {
  addHouseKeeperHappyWithController, deleteData, getHouseKeeperHappyWithController,
  getHouseKeeperBookingOptionsController, addHouseKeeperBookingOptionController, editHouseKeeperBookingOptionController
} from '../../../Controllers/AppManagement/houseKeeper';
import { __constants, __snackBarSeverity, __snackBarText } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';
import TextDescriptionListManager from '../common/TextDescriptionListManager';

const CLEANING_TYPE = "cleaning-type";
const ADD_ON = "add-on";

export default function HouseKeeperHappyWith() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <Page>
      <ImageTextListManager
        navTitle="Housekeeper help"
        dialogTitle="Add new happy with"
        textLabel="Happy with"
        getData={getHouseKeeperHappyWithController}
        addData={addHouseKeeperHappyWithController}
        deleteData={deleteData}
        editTitle="Update happy with"
        fullHeight={false}
        setProfileNavTitle={setProfileNavTitle}
        __constants={__constants}
        __snackBarText={__snackBarText}
        __snackBarSeverity={__snackBarSeverity}
        mainContext={mainContext}
      />

      <GroupHeader>
        <h2>Customer booking options</h2>
        <p>
          <InfoOutlined fontSize="inherit" />
          <span>Shown only to customers when they post a job or book a housekeeper. Housekeepers don't fill these during signup.</span>
        </p>
      </GroupHeader>

      <Grid>
        <TextDescriptionListManager
          title="What kind of cleaning do you need?"
          choiceLabel="Single choice"
          textLabel="Cleaning type"
          getData={() => getHouseKeeperBookingOptionsController(CLEANING_TYPE)}
          addData={(name, description) => addHouseKeeperBookingOptionController(CLEANING_TYPE, name, description)}
          editData={editHouseKeeperBookingOptionController}
          deleteData={deleteData}
          __snackBarText={__snackBarText}
          __snackBarSeverity={__snackBarSeverity}
          mainContext={mainContext}
        />

        <TextDescriptionListManager
          title="Optional Add-ons"
          choiceLabel="Multiple choice"
          textLabel="Add-on"
          showDescription={false}
          getData={() => getHouseKeeperBookingOptionsController(ADD_ON)}
          addData={(name, description) => addHouseKeeperBookingOptionController(ADD_ON, name, description)}
          editData={editHouseKeeperBookingOptionController}
          deleteData={deleteData}
          __snackBarText={__snackBarText}
          __snackBarSeverity={__snackBarSeverity}
          mainContext={mainContext}
        />
      </Grid>
    </Page>
  );
}

const Page = styled("div")`
  padding-bottom: 3rem;
`;
const GroupHeader = styled("div")`
  margin: 2rem 0 0.9rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(101, 122, 144, 0.22);
  h2{ margin: 0 0 0.3rem; font-family: "semi-bold"; font-size: 1.05rem; }
  p{
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 82%;
    color: rgba(101, 122, 144, 1);
  }
`;
const Grid = styled("div")`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 1.25rem;
  align-items: start;
  @media (max-width: 1100px){ grid-template-columns: minmax(0, 1fr); }
`;
